export const projects = [
  {
    title: "Spring Boot",
    subtitle: "Spring Boot/MVC",
    description:
      "Experienced in Spring Boot, focusing on rapid development, microservices architecture, and seamless integration, delivering scalable and maintainable web applications.",
    image: "./boot.gif",
  },
  {
    title: "Datastructes",
    subtitle: "Collections and Arrays",
    description:
      "Proficient in leveraging data structures to optimize algorithmic efficiency, enhancing the design and implementation of robust software solutions",
    image: "./DS.gif",
  },
  {
    title: "AWS",
    subtitle: "Amazon Web Services",
    description:
      "Skilled in AWS services, specializing in cloud architecture, deployment, scalability, and security, ensuring optimized, cost-effective, and reliable cloud solutions.",
    image: "./aws.gif",
  },
  {
    title: "SDLC",
    subtitle: "Software Development Life Cycle",
    description:
      "Expertise in key phases of the Software Development Life Cycle (SDLC), with a strong focus on design, implementation, testing, and deployment, ensuring the efficient delivery of robust and reliable software solutions.",
    image: "./sdlc.gif",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];


export const experiences = [
  {
    Title:
      "1. Technical Consultant",
    image: "https://scontent-dfw5-1.xx.fbcdn.net/v/t39.30808-6/327175161_575287970798918_1022476788466031377_n.jpg?_nc_cat=101&ccb=1-7&_nc_sid=efb6e6&_nc_ohc=RWfL9p6DA2sAX_xbCBJ&_nc_ht=scontent-dfw5-1.xx&oh=00_AfArYAC8ErDW8q723LH5L92bcp4gTImcQwgZ1nv9Y50OYA&oe=65BCF517",
    Duration: "05/2023 - Now",
    company: "Maharishi Int'l University",
    Location: "Fairfield, IA USA",
    Technologies: "Java, Python, JavaScript"
  },
  {
    Title:
      "2. Software Engineer",
    image: "https://media.licdn.com/dms/image/C4D0BAQEtonVHDHqAZQ/company-logo_200_200/0/1639415775313/kforce_logo?e=1714608000&v=beta&t=SSUVDFrHyTCYVTh77rLaNGngYV4E4-J8kIu2-aWItzs",
    Duration: "10/2021 - 02/2023",
    company: "KForce Inc.",
    Location: "Tampa, FL USA",
    Technologies: "Java, Python, JavaScript"
  },
  {
    Title:
      "3. Software Developer",
    image: "https://media.licdn.com/dms/image/C4D0BAQGJFi2MqnJysg/company-logo_200_200/0/1630560784470/mmcytech_logo?e=1714608000&v=beta&t=1xPDkug3jv9d2M2f5ogYO2vxmrAZcFFy31YuBeLbLVg",
    Duration: "08/2019 - 01/2021",
    company: "MMCY Technologies",
    Location: "Addis Ababa, Ethiopia",
    Technologies: "Java, Python, JavaScript"
  },
  {
    Title:
      "4. Junior Software Developer",
    image: "https://avatars.githubusercontent.com/u/29814886?s=200&v=4",
    Duration: "12/2016 - 07/2019",
    company: "Kelal Tech PLC",
    Location: "Addis Ababa, Ethiopia",
    Technologies: "Java, Python, JavaScript"
  },
];

export const skills = [
  "Java",
  "Spring Boot",
  "JavaScript",
  "ReactJS",
  "Python",
  "AWS",
  "Node",
  "MongoDB",
  "REST",
  "And More..."
];
